<script>
export default {
  name: "callouts",
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <div v-if="alert.message" :class="'alert ' + alert.type">
    {{ alert.message }}
  </div>
</template>
